export enum TaskType {
    PHOTO = 1,
    CONFIRM = 2,
    NUMBER = 3,
    AUDIO = 4,
    VIDEO = 5,
    DATE = 6,
    DRAW = 7,
    SELECT = 8,
    TEXT = 9,
    DURATION = 10,
    SCORE = 11,
    PROBLEM = 12,
    MATRIX = 13,
    GOTO = 14,
    SAMPLETEXT = 15,
    SAMPLEIMAGE = 16,
    SELECTAPI = 17
}